import { UI, Checkbox } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { HStack, Pressable, VStack } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemCaptions,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { useFundsAssetContext } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/Funds';
import { useGlobalProductContext } from '../../../../../contexts';
import { availableProductFundsConstant } from '../constants';

import { FundsListItemTypes } from '.';

export const FundsListItemDesktop: React.FC<FundsListItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = useFundsAssetContext();
  const { product, infoGetter } = useGlobalProductContext();

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected(offer);
  };

  const getFlex = (index: number) => {
    const currentHead = availableProductFundsConstant.tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  const selectionInfo = infoGetter(offer, 'productId');
  const isSelected = selectionInfo?.isSelected || false;
  const handleSelect = () => {
    selectionInfo?.handleSelect?.(offer, 'productId');
  };

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']} h="80px">
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <Checkbox
          testId={`checkbox-fund-${offer.productId}`}
          options={[{ label: '', value: offer.productId?.toString() || '' }]}
          selectedValues={isSelected ? [offer.productId?.toString() || ''] : []}
          onChange={handleSelect}
          optionPadding={{ bottom: 0, right: 0 }}
        />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <HStack alignItems="center" space={Spacing['inline.xxxs']}>
          <UI.Tooltip testID="details-tooltip" label={'Veja mais detalhes\nsobre este produto'}>
            <Pressable onPress={onOpenDetailsModal}>
              <UI.Icon name="Info" size="xs" />
            </Pressable>
          </UI.Tooltip>
          <VStack space={Spacing['stack.quarck']} flex={1} pr={Spacing['inline.xxxs']}>
            <TableContentItemText>{offer.productNameNormalized}</TableContentItemText>
            <TableContentItemCaptions icons={offer.captions} />
          </VStack>
        </HStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <VStack>
          <TableContentItemText>{offer.managerName}</TableContentItemText>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <VStack>
          <TableContentItemText>{offer.productCategoryNormalized}</TableContentItemText>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <VStack>
          <TableContentItemText>{offer.profitabilityTwelveMonthsNormalized}</TableContentItemText>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>{offer.administrationFee}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TableContentItemText>
          {Utils.Mask.Money(offer.participateMinimumAmount)}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <TableContentItemText>
          {Utils.Mask.Money(offer.applicationMinimumAmount)}
        </TableContentItemText>
      </TableContentItemColumn>
    </TableContent>
  );
};
